<input
  type="text"
  matInput
  [formControl]="_formControl"
  [placeholder]="input.placeholder | parse: context | async"
  (blur)="onBlur($event)"
  (keyup.enter)="onEnter()"
  (keyup.escape)="onEscape()"
/>
